<p-confirmDialog></p-confirmDialog>

<p-toast [life]="10000" />

<div id="fundcodes" data-cy="fundcodes">
    <h1>Fund Codes</h1>
    <p-card>
      <!-- [classes]="['absolute mt-3']" -->
        <rc-generic-button 
            level="secondary"
            borderStyle="solid"
            [classes]="['mt-2 mb-4']"
            label="Add New Fund Code"
            (clickHandler)="onAddEditFundCode()"
            data-cy="btn-add-fundcode"
            />

        <rc-generic-table 
            exportLabel="Campaign Settings Fundcodes"
            [columns]="columns"
            [rows]="data"
            data-cy="table-data"
            [formattedText]="formattedText"
            (actionClicked)="onActionClicked($event)" />
    </p-card>
</div>

<!-- Add/Edit MODAL -->
<p-dialog [(visible)]="showAddEditDialog"
    [modal]="true"
    header="{{ isEditMode ? 'Edit Fund Code' : 'Add Fund Code' }}"
    styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

  <ng-container>
    <form [formGroup]="addEditFundCode">
        <div class="formgrid grid">
          <div class="field col-12" *ngIf="isEntityCampaign">
              <label for="childCampaignId" class="field-label required">Campaign</label>
              <p-dropdown id="childCampaignId" formControlName="childCampaignId"
                            [options]="childCampaigns" optionLabel="name"
                            placeholder="Select Campaign" optionValue="childCampaignId" data-cy="dropdown-child-campaign"/>
              <div *ngIf="addEditFundCode.get('childCampaignId')?.invalid && addEditFundCode.get('childCampaignId')?.touched"
                class="block p-error">
                <small id="child-campaign-error" class="error">
                 Please select a child campaign to proceed.
                </small>
              </div>
          </div>
            <div class="field col-12">
                <label for="fundCode" class="field-label required">Fund Code</label>
                <input id="fundCode" pInputText formControlName="fundCode" type="text" placeholder="" data-cy="input-fundcode"/>    
                <div *ngIf="addEditFundCode.get('fundCode')?.invalid && addEditFundCode.get('fundCode')?.touched"
                  class="block p-error">
                  <small id="fund-code-error" class="error">
                    Please enter fund code to proceed.
                  </small>
                </div>
            </div>
            <div class="field col-12">
                <label for="fundTypeId" class="field-label required">Election</label>                    
                <p-dropdown id="fundTypeId" formControlName="fundTypeId"
                            [options]="fundTypes" optionLabel="value"
                            placeholder="Select Fund Type" optionValue="key" data-cy="dropdown-type"/>
                <div *ngIf="addEditFundCode.get('fundTypeId')?.invalid && addEditFundCode.get('fundTypeId')?.touched"
                    class="block p-error">
                  <small id="fund-code-type-id-error" class="error">
                    Please select a fund type to continue.
                  </small>
                </div>
            </div>
            <div class="field col-12">
                <label for="year" class="field-label required">Year</label>
                <input id="year" pInputText formControlName="year" placeholder="" type="text" data-cy="input-year"/>
                <div *ngIf="addEditFundCode.get('year')?.invalid && addEditFundCode.get('year')?.touched"
                    class="block p-error">
                  <small id="year-error" class="error">
                    Please enter the year to proceed.
                  </small>
                </div>
            </div>
            <div class="field col-12">
                <p-toggleButton name="isDefault" onLabel="Default" offLabel="Not Default" onIcon="pi pi-check-circle"
                    offIcon="pi pi-ban" formControlName="isDefault" data-cy="toggle-default"/>
            </div>
        </div>
    </form>
  </ng-container>   

  <ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="onCloseAddEditDialog()" data-cy="btn-cancel"/>
    <rc-generic-button label="Save" (click)="onSaveFundcode()" data-cy="btn-save"/>
  </ng-template>
</p-dialog>
